<template>
  <main>
    <h1>Cos'è Comiso News</h1>
    <article>
      <p>
        <b>Comiso News</b> nasce nel <b>2009</b> come
        <b>giornale online partecipativo</b>, con l'intenzione di coinvolgere la
        comunità nella produzione dei contenuti. Nel corso dei primi due anni
        furono lanciati due progetti. Il primo,
        <b>"Segnala i problemi in giro"</b>, consentiva ai cittadini di
        segnalare i problemi della città pubblicando un post e allegando una
        foto del problema. Il secondo progetto, <b>"Il Sindaco risponde"</b>,
        sfruttava il sitema di domande e risposte fornito da Google e utilizzato
        da Obama durante il suo primo mandato da Presidente degli Stati Uniti.
        All'interno della sezione dedicata del sito Comisonews.com, i cittadini
        potevano fare una domanda al Sindaco di Comiso che avrebbe risposto
        pubblicamente con un post all'interno della piattaforma.
      </p>
      <p>
        Tra il <b>2012</b> e il <b>2015</b> Comiso News cambia la sua filosofia
        e si dedica allo sviluppo di un sistema per raccogliere e pubblicare in
        un unico sito tutte le notizie e le informazioni sulla città di Comiso
        presenti su Internet. L'obiettivo è quello di fornire ai cittadini uno
        strumento insostituibile per avere in tempo reale tutte le notizie, le
        immagini, i video e le conversazioni nei social che riguardano Comiso.
        Così viene realizzato il <b>primo sito aggregatore di news</b> della
        città che contiene anche gli aggregatori di Twitter, Flickr, Instagram e
        YouTube.
      </p>
      <p>
        Il <b>2017</b> è l'anno dell'<b>evoluzione tecnologica</b>: Comiso News
        non è più semplice sito aggregatore di news, ma diventa una
        <b>Progressive Web App</b>, accessibile da
        <b>qualsiasi dispositivo mobile</b> e "reattiva", che consente di
        ricevere aggiornamenti in tempo reale tramite <b>notifiche push</b>.
        Comiso News può essere aggiunta alla homescreen di qualsiasi smartphone,
        <b>proprio come un'applicazione nativa</b>. La home page di Comiso News
        adesso contiene le
        <b>ultime tre notizie pubblicate dai principali quotidiani online</b>
        della provincia di Ragusa e gli
        <b>aggregatori dei social network</b> che consentono di avere una
        panoramica delle conversazioni su Comiso e di visualizzare gli ultimi
        video caricati su YouTube relativi a Comiso. Nella home troverete anche
        l'aggregatore delle <b>news su Comiso selezionate da Google News</b> in
        base alla loro rilevanza sul Web. Le sezioni tematiche raccolgono, in
        base all'argomento, tutti gli ultimi articoli pubblicati nelle
        principali testate giornalistiche online della provincia di Ragusa che
        parlano di Comiso.
      </p>
      <p>
        <b class="underline">Comiso News non è una testata giornalistica</b>, ma
        un aggregatore di news e contenuti multimediali che riguardano la città
        di Comiso e fornisce in tempo reale una panoramica completa degli
        avvenimenti della città.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  head() {
    return {
      title: `Cos'è Comiso News - Comiso News`,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '~/assets/vars.pcss';
@import '~/assets/media.pcss';

h1 {
  margin-bottom: $main-padding;
}

main {
  padding: $main-padding;
}

article {
  text-align: justify;
}

.underline {
  text-decoration: underline;
}
</style>
